module.exports = __webpack_public_path__ + "img/tj.0b87093b.svg";